import React from 'react';
import type {SxProps} from '@mui/material';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
import {useLocalization} from 'localization';
import {Text} from 'components/text';

export interface AreYouSureDialogProps {
  id: string;
  keepMounted: boolean;
  open: boolean;
  onClose: (value?: boolean) => void;
  doubleConfirm?: boolean;
  doubleConfirmMessage?: string;
  prevent?: string;
}

const AreYouSureDialogSx: SxProps = {
  '& .MuiDialog-paper': {width: '80%'},
};

export const AreYouSureDialog: React.FC<AreYouSureDialogProps> = ({
  onClose,
  open,
  doubleConfirm,
  doubleConfirmMessage,
  prevent,
  ...other
}) => {
  const {t} = useLocalization();
  const [doubleConfirmed, setDoubleConfirmed] = React.useState(false);

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    if (!doubleConfirm || doubleConfirmed) {
      onClose(true);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDoubleConfirmed(event.target.checked);
  };

  return (
    <Dialog sx={AreYouSureDialogSx} maxWidth="xs" open={open} {...other}>
      <DialogTitle>{t('general.areyousure')}</DialogTitle>
      {doubleConfirm ? (
        <DialogContent dividers>
          <FormControlLabel
            disabled={!!prevent}
            control={
              <Checkbox
                aria-label="doubleConfirm"
                name="doubleConfirm"
                value={doubleConfirmed}
                onChange={handleChange}
              />
            }
            label={doubleConfirmMessage ?? t('general.doubleAreYouSure')}
          />
        </DialogContent>
      ) : null}
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          {t('general.cancel')}
        </Button>
        {prevent ? (
          <Text variant={'label'} kind={'error'}>
            {prevent}
          </Text>
        ) : (
          <Button onClick={handleOk}>{t('general.yes')}</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
